import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../../ui_game/UIGameManager'
import {UIGameTradeOfferViewContainer} from './UIGameTradeOfferViewContrainer'
import {UIGamePlayerAvatarView} from '../../ui_game/ui_game_players/UIGamePlayerAvatarView'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {GameColor} from '../../GameColor'
import {UIGameFadeAnimation} from '../../ui_canvas_engine/animation/UIGameFadeAnimation'
import {UIGameGoToPointAnimation} from '../../ui_canvas_engine/animation/UIGameGoToPointAnimation'
import {UIGameAnimationBase} from '../../ui_canvas_engine/animation/UIGameAnimationBase'
import {TradeValidator} from '@colonist/game-mechanic-validators'

export class UIGameTradeOfferView extends SectionBgView {
    private readonly uiGameManager: UIGameManager
    readonly stateController: TradeValidator
    private readonly tradeOfferViewContainer: UIGameTradeOfferViewContainer
    private readonly counterOfferPlayerAvatarView?: UIGamePlayerAvatarView
    animation: UIGameAnimationBase | undefined = undefined
    isFirstMovement: boolean = true
    isFadingOut: boolean = false

    constructor(uiGameManager: UIGameManager, stateController: TradeValidator, scrollBoxWidth: number, offerHeight: number, container: PIXI.Container) {
        const canvas = uiGameManager.canvasController

        const height = offerHeight - canvas.margin
        super(0, 0, scrollBoxWidth, height, container, true)

        this.uiGameManager = uiGameManager
        this.stateController = stateController

        const counterOfferPlayerAvatarSize = height / 2 * 0.65
        const counterOfferPlayerAvatarMargins = canvas.margin
        const counterOfferPlayerSectionSize = counterOfferPlayerAvatarSize + counterOfferPlayerAvatarMargins * 2

        const isCounterOffer: boolean = this.stateController.state.counterOfferInResponseToTradeId != undefined
        const tradeViewContainerWidth = isCounterOffer ? this.width - counterOfferPlayerSectionSize : this.width
        const tradeViewContainerX = this.width - tradeViewContainerWidth
        this.tradeOfferViewContainer = new UIGameTradeOfferViewContainer(uiGameManager, this.stateController, tradeViewContainerX, tradeViewContainerWidth, height, this)

        if(isCounterOffer) {
            const playerControllerState = this.uiGameManager.gameController.getPlayerState(this.stateController.state.creator)
            this.counterOfferPlayerAvatarView = new UIGamePlayerAvatarView(counterOfferPlayerAvatarMargins, 0, counterOfferPlayerAvatarSize, this, playerControllerState)
            this.counterOfferPlayerAvatarView.centerYInParent()
            const alpha = 0.43
            this.drawBg(GameColor.Color.GrayScale25, alpha)
        }
    }

    rejectTrade() {
        this.tradeOfferViewContainer.givingHalf.rejectTrade()
    }

    onPlayerResponseStatuses() {
        this.tradeOfferViewContainer.onPlayerResponseStatuses()
    }

    onPlayerCreatingCounterOffer() {
        this.tradeOfferViewContainer.onPlayerCreatingCounterOffer()
    }

    onPlayerActionState() {
        this.tradeOfferViewContainer.onPlayerActionState()
    }

    onPlayerControllerState() {
        this.tradeOfferViewContainer.onPlayerControllerState()
        void this.counterOfferPlayerAvatarView?.refreshPlayerIcon()
    }

    fadeIn() {
        this.animation?.stop()
        const fadeInAnimation = new UIGameFadeAnimation(this, 200, {
            initialAlpha: 0,
            fadeSpeed: 0.1,
            completionPercentageToStartFade: 0,
            isFadeIn: true,
        })
        fadeInAnimation.setOnStopCallback(() => {
            this.animation = undefined
            this.alpha = 1
            this.toggleActionButtonInteractivity(true)
        })
        this.animation = fadeInAnimation
        this.toggleActionButtonInteractivity(false)
        fadeInAnimation.start()
    }

    fadeOut(removeCallback: () => void) {
        this.animation?.stop()
        const fadeOutAnimation = new UIGameFadeAnimation(this, 200, {
            initialAlpha: 1,
            fadeSpeed: 0.1,
            completionPercentageToStartFade: 0,
            isFadeIn: false,
        })
        fadeOutAnimation.setOnStopCallback(() => {
            this.animation = undefined
            removeCallback()
        })
        this.isFadingOut = true
        this.animation = fadeOutAnimation
        this.toggleActionButtonInteractivity(false)
        fadeOutAnimation.start()
    }

    moveVertically(newY: number, updateCallback?: () => void) {
        this.animation?.stop()
        const destinationPoint = new PIXI.Point(this.x, newY)
        const moveAnimation = new UIGameGoToPointAnimation(this, destinationPoint)
        moveAnimation.setOnStopCallback(() => {
            this.animation = undefined
            this.y = newY
            this.toggleActionButtonInteractivity(true)
            updateCallback?.()
        })
        this.animation = moveAnimation
        this.toggleActionButtonInteractivity(false)
        moveAnimation.start()
    }

    override destroy(options?: PIXI.IDestroyOptions | boolean) {
        this.animation?.stop()
        super.destroy(options)
    }

    private toggleActionButtonInteractivity(isInteractive: boolean) {
        this.tradeOfferViewContainer.givingHalf.toggleActionButtonInteractivity(isInteractive)
    }
}
